import { render, staticRenderFns } from "./CalendarWidget.vue?vue&type=template&id=266dcdf2&"
import script from "./CalendarWidget.vue?vue&type=script&lang=js&"
export * from "./CalendarWidget.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports